import { TIdToPageMap } from 'models/common.model'
import { lazy } from 'react'
import { PageIdStylioCapsule71 } from './pages'

export const ID_TO_PAGE_MAP_STYLIO_CAPSULE_71: TIdToPageMap = {
  [PageIdStylioCapsule71.SUBSCRIPTIONS_CAPSULE_71]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_71/pages/CapsuleSubscriptionPage'
      ).then((m) => ({
        default: m.CapsuleSubscriptionPage,
      })),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_71/pages/CapsuleSubscriptionPage'),
  },
  [PageIdStylioCapsule71.SUB_UPSELL_CAPSULE_71]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_71/pages/sub-upsell/SubUpsell').then(
        (m) => ({
          default: m.SubUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_71/pages/sub-upsell/SubUpsell'),
  },
  [PageIdStylioCapsule71.FACE_STYLING_PDF_UPSELL_CAPSULE_71]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_71/pages/third-pdf-upsell/ThirdPdfUpsell'
      ).then((m) => ({
        default: m.ThirdPdfUpsell,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_71/pages/third-pdf-upsell/ThirdPdfUpsell'
      ),
  },
  [PageIdStylioCapsule71.PROPORTIONS_PDF_UPSELL_CAPSULE_71]: {
    Component: lazy(() =>
      import('nove8/cohorts/stylio_capsule_71/pages/ProportionsPdfUpsell').then(
        (m) => ({
          default: m.ProportionsPdfUpsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/stylio_capsule_71/pages/ProportionsPdfUpsell'),
  },
  [PageIdStylioCapsule71.DOWNLOAD_CAPSULE_71]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/stylio_capsule_71/pages/download-capsule/DownloadDefault'
      ).then((m) => ({
        default: m.DownloadDefault,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/stylio_capsule_71/pages/download-capsule/DownloadDefault'
      ),
  },
}
